import React from 'react';
import Icon from "./Icon"
import {Tooltip} from "react-tooltip";
import {Link} from "react-router-dom";
import SettingsPanel from "../workflow/Settings";
import {Save, PieChart, Settings, AlertCircle} from "react-feather";
import Button from "../../components/button";

export default (props) => {

    const {
        journey,
        showOptions,
        availableNodes,
        currentNode,
        previousNode,
        onClickSave
    } = props


    const onDragStart = (event, component) => {
        event.dataTransfer.setData('text/plain', JSON.stringify(component));
        event.dataTransfer.effectAllowed = 'move';
    };

    const SettingsOptions = {
        journey     : journey,
        currentNode : currentNode,
        previousNode: previousNode,
    }


    return (
        <aside className="components-container">
            <div className="actions">
                <div>

                    <Link
                        data-place={'left'}
                        data-tip={`Logs`}
                        to={`/journeys/${props.journey._id.$oid}/logs`}
                        className="btn btn-sm btn-icon btn-white">
                        <AlertCircle/>
                    </Link>


                    <Link
                        data-place={'left'}
                        data-tip={`History`}
                        to={`/journeys/${props.journey._id.$oid}/statistics`}
                        className="btn btn-sm btn-icon btn-white">
                        <PieChart/>
                    </Link>


                    <Link
                        data-place={'left'}
                        data-tip={`Configuration`}
                        to={`/journeys/${props.journey._id.$oid}`}
                        className="btn btn-sm btn-icon btn-white">
                        <Settings/>
                    </Link>

                    {
                        typeof onClickSave == "function" && <>
                            <Button isReady={true} size="sm" color="primary" label="Save" onClick={onClickSave}/>
                        </>
                    }


                </div>


                <Tooltip effect="solid" type="dark"/>
            </div>
            {showOptions && <div className="ComponentOptions">
                <div className="Title">
                    {currentNode && currentNode.data && <div>
                        <Icon className={currentNode.data.slug} iconName={currentNode.data.icon}/>
                        {currentNode.data.label}
                    </div>}
                </div>
                <div className="Content">
                    {currentNode.data && <div>
                        <SettingsPanel {...SettingsOptions}/>
                    </div>}
                </div>

            </div>}
            {!showOptions && <div className="components">
                {availableNodes?.[0]?.components?.length > 0 && <>
                    <div className="description">You can drag these nodes to the pane on the right.</div>
                    <div className="inner-content mt-4 d-flex flex-wrap justify-content-center">
                        {availableNodes?.[0]?.components.map((component, index) => {
                            return <div key={`Component_${index}`} className={`Component dndnode ${component.type}`} onDragStart={(event) => onDragStart(event, component)} draggable={!component.disabled}>
                                <Icon className={component.slug} iconName={component.icon}/>
                                <span className="Label">{component.label}</span>
                            </div>
                        })}
                    </div>
                </>}
            </div>}
        </aside>
    );
};
